import { Component, inject } from '@angular/core';
import { StoreService } from '@shared/store';
import { selectDebugSettings, setDebugSettings } from '@shared/store/slices/debug';

@Component({
  selector: 'app-debug-config',
  templateUrl: './debug-config.component.html',
  styleUrls: ['./debug-config.component.scss'],
  standalone: false,
})
export class DebugConfigComponent {
  private store = inject(StoreService);

  get downloadMedia(): boolean {
    const debug = this.store.select(selectDebugSettings());
    return Boolean(debug.downloadMedia);
  }
  set downloadMedia(value: boolean) {
    this.store.dispatch(
      setDebugSettings({
        downloadMedia: value,
      }),
    );
  }

  get downloadFrames(): boolean {
    const debug = this.store.select(selectDebugSettings());
    return Boolean(debug.downloadFrames);
  }
  set downloadFrames(value: boolean) {
    this.store.dispatch(
      setDebugSettings({
        downloadFrames: value,
      }),
    );
  }

  get enableFaceTrackerUi(): boolean {
    const debug = this.store.select(selectDebugSettings());
    return Boolean(debug.enableFaceTrackerUi);
  }
  set enableFaceTrackerUi(value: boolean) {
    this.store.dispatch(
      setDebugSettings({
        enableFaceTrackerUi: value,
      }),
    );
  }
}
